import chart from "./chart"
export default{
    chart
}